import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { signOut } from "firebase/auth";
import { auth } from "../../../../firebase";
import OnboardingUserTypeStep from "./components/OnboardingUserTypeStep";
import { Text } from "../../../../design/text";
import { useMatter } from "../../../../contexts/MatterContext";
import { useUser } from "../../../../contexts/UserContext";
import { OnboardingUserForm } from "../../../../models/OnboardingUserForm";

const OnboardingHome = () => {
  const { currentUser, updateUser } = useUser();
  const [isSaving, setIsSaving] = useState(false);
  const [searchParams] = useSearchParams();
  const [step, setStep] = useState(parseInt(searchParams.get("step") || "0"));
  const navigate = useNavigate();
  const [formData, setFormData] = useState<OnboardingUserForm>({});

  const nextStep = async () => {
    if (step === 1) {
      setIsSaving(true);
      try {
        await updateUser(currentUser!._id, null, formData);
        if (formData.type === "user") {
          navigate(`/onboarding/matter`);
        } else {
          navigate(`/onboarding/professional`);
        }
      } catch (e) {
        console.error(e);
      } finally {
        setIsSaving(false);
      }
      return;
    } else {
      setStep((prev) => prev + 1);
    }
  };
  const previousStep = () => setStep((prev) => prev - 1);

  const onLogoutButtonPressed = () => {
    signOut(auth);
    navigate("/");
  };

  return (
    <>
      <div className="absolute flex items-center justify-between w-full max-w-screen-md p-4">
        <Text
          onClick={onLogoutButtonPressed}
          className="cursor-pointer text-zinc-500 hover:text-zinc-700 dark:text-zinc-400 dark:hover:text-zinc-300"
        >
          Logout
        </Text>
      </div>
      <div className="flex flex-col items-center justify-center min-h-screen">
        <div className="w-full max-w-screen-md">
          <OnboardingUserTypeStep
            formData={formData}
            setFormData={setFormData}
            onBack={previousStep}
            onStepComplete={nextStep}
          />
        </div>
      </div>
    </>
  );
};

export default OnboardingHome;
